import { Component, Input, OnInit } from '@angular/core';

import { IAuthorityHistoryChange } from '../models/authority-history-change.interace';
import { IAuthorityHistoryCommonChange } from '../models/authority-history-common.interface';
import { IAuthorityHistoryModel } from '../models/authority-history.interface';
import { IConfirmationDialogModel } from '../models/confirmaDialogModel';
import { EICSTatus } from '../models/eic-status.enum';
import { Source } from '../models/source.enum';
import { Status } from '../models/status.enum';
import { TrackAuthority } from '../models/trackauthority';
import { DataService } from '../services/data.service';
import { ATMEventData, EventBusService, EventType } from '../services/eventbus.service';
import { AppConstant } from '../common/app.constant';

@Component({
  selector: 'shared-authority-modal',
  templateUrl: './shared-authority-modal.component.html',
  styleUrls: ['./shared-authority-modal.component.scss']
})
export class SharedAuthorityModalComponent implements OnInit {
  displaySharedModal = true;
  sharedAuthority: TrackAuthority;
  actionForUserConfirmation: Status | Source;
  authorityForUserConfirmation: TrackAuthority = null;
  showConfirmation: boolean = false;
  confirmationDialogData: IConfirmationDialogModel;
  notificationData: any;
  acceptLabel: String;
  rejectLabel: String;
  columnNames = [];
  sharedby: String;
  requestStatus: Status;
  confirmationAction: Status;
  showReason: boolean = false;
  private primaryUserRacf: String;
  private showaffirmations = true;
  showModification: boolean;
  modificationArray;
  authorityHistoryChange: IAuthorityHistoryChange[];
  authorityHistoryCommonChange: IAuthorityHistoryCommonChange;
  private authorityChangeRequestId;
  public text: any;
  public showRejectReason: boolean = false;
  public affirmationAction = Status.SHARING_AUTHORITY;
  isActionAllowed: boolean = false;
  rejectModification: boolean = false;
  blocked: boolean = false;

  @Input() authority;
  @Input() sharedAuthorityNotification: any;

  constructor(private dataService: DataService, private eventBusService: EventBusService) {}

  ngOnInit() {
    this.sharedAuthority = this.authority;
    this.confirmationDialogData = {
      header: AppConstant.CONFIRMATION_TEXT,
      confirmBtnTitle: AppConstant.confirmBtnTitle_YES,
      modalHeading: AppConstant.HASH_LABEL + this.sharedAuthority.ec1Number,
      modalSecondline: AppConstant.REJECT_CONFIRMATION_MESSAGE
    };
    const loggedInEicStatus = this.authority.eicChangeRequests[this.authority.loggedInEICDetail?.eicUserId]
      ? this.authority.eicChangeRequests[this.authority.loggedInEICDetail.eicUserId].authorityChangeRequestStatus
      : this.authority.modifyReportbyChangeRequest?.authorityChangeRequestStatus;
    this.columnNames = AppConstant.SA_POP_UP_COLUMN_NAMES;
    if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_SHARED) {
      this.acceptLabel = AppConstant.AUTH_SHARED_ACCEPT_LABEL;
      this.rejectLabel = AppConstant.AUTH_SHARED_REJECT_LABEL;
      this.showRejectReason = true;
      this.setAuthorityRequestLoginUser();
      this.isActionAllowed = loggedInEicStatus === Status.SHARING_INITIATED.toString();
    } else if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_RELEASED) {
      this.acceptLabel = AppConstant.AUTH_RELEASE_ACCEPT_LABEL;
      this.rejectLabel = AppConstant.AUTH_RELEASE_REJECT_LABEL;
      this.confirmationDialogData.modalSecondline = AppConstant.RELEASE_LATER_CONFIRMATION;
      this.showRejectReason = true;
      this.showReason = true;
      this.affirmationAction = Status.SHARING_RELEASE;
      this.setAuthorityRequestLoginUser();
      this.isActionAllowed = loggedInEicStatus === Status.UNSHARING_INITIATED.toString();
    } else if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_SHARE_REQUEST) {
      this.acceptLabel = AppConstant.AUTH_SHARED_REQUEST_ACCEPT_LABEL;
      this.rejectLabel = AppConstant.AUTH_SHARED_REQUEST_REJECT_LABEL;
      this.showaffirmations = false;
      this.text = AppConstant.REQUESTED_BY_TEXT;
      this.showRejectReason = true;
      let requestedRacf = this.getRacf(this.sharedAuthorityNotification.item.message);
      this.sharedAuthority.employeeInCharges.forEach(eic => {
        if (eic.eicUserId === requestedRacf.trim()) {
          this.sharedby = `${eic.eicUserId} - ${eic.eicEmployeeName}`;
          this.primaryUserRacf = eic.eicUserId;
        }
      });
      this.authorityChangeRequestId =
        this.sharedAuthorityNotification.item.authorityChangeRequestId ||
        (this.authority.eicChangeRequests[requestedRacf.trim()] &&
          this.authority.eicChangeRequests[requestedRacf.trim()].authorityChangeRequestId);
      this.isActionAllowed =
        this.authorityChangeRequestId &&
        this.authority.eicChangeRequests[requestedRacf.trim()] &&
        this.authority.eicChangeRequests[requestedRacf.trim()].authorityChangeRequestStatus === Status.SHARING_REQUESTED.toString();
    } else if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_MODIFIED) {
      this.acceptLabel = AppConstant.AUTH_MODIFIED_ACCEPT_LABEL;
      this.rejectLabel = AppConstant.AUTH_MODIFIED_REJECT_LABEL;
      this.affirmationAction = Status.CHANGE_REQUEST;
      this.confirmationDialogData.modalSecondline = AppConstant.CANCEL_MODIFICATIOB_CONFIRMATION_TEXT;
      this.showaffirmations = true;
      this.showRejectReason = true;
      this.authorityChangeRequestId =
        this.sharedAuthorityNotification.item.authorityChangeRequestId ||
        this.sharedAuthority.modifyReportbyChangeRequest.authorityChangeRequestId;
      this.getAuthorityModificationByChangeRequest(this.sharedAuthority.id, this.authorityChangeRequestId);
      this.isActionAllowed =
        this.authority.loggedInEICDetail?.lastChangeRequestStatus === EICSTatus.PENDING &&
        (loggedInEicStatus === Status.CHANGE_PROPOSED.toString() ||
          loggedInEicStatus === Status.CHANGE_PROPOSED_PARTIALLY_ACCEPTED.toString());
    } else if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_ACCEPTED_MODIFICATION) {
      this.acceptLabel = AppConstant.AUTH_SUBMIT_ACCEPT_LABEL;
      this.rejectLabel = AppConstant.AUTH_SUBMIT_REJECT_LABEL;
      this.affirmationAction = Status.CHANGE_REQUEST;
      this.confirmationDialogData.modalSecondline = AppConstant.CANCEL_MODIFICATIOB_CONFIRMATION_TEXT;
      this.showRejectReason = true;
      this.authorityChangeRequestId =
        this.sharedAuthorityNotification.item.authorityChangeRequestId ||
        this.sharedAuthority.modifyReportbyChangeRequest.authorityChangeRequestId;
      this.getAuthorityModificationByChangeRequest(this.sharedAuthority.id, this.authorityChangeRequestId);
      this.isActionAllowed = loggedInEicStatus === Status.CHANGE_PROPOSED_ACCEPTED.toString();
    } else if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_ACCEPTED_MODIFICATION_DISPATCHER) {
      this.acceptLabel = AppConstant.AUTH_MODIFIED_ACCEPT_LABEL;
      this.rejectLabel = AppConstant.AUTH_MODIFIED_REJECT_LABEL;
      this.affirmationAction = Status.CHANGE_REQUEST;
      this.confirmationDialogData.modalSecondline = AppConstant.CANCEL_MODIFICATIOB_CONFIRMATION_TEXT;
      this.showRejectReason = true;
      this.authorityChangeRequestId =
        this.sharedAuthorityNotification.item.authorityChangeRequestId ||
        this.sharedAuthority.modifyReportbyChangeRequest.authorityChangeRequestId;
      this.getAuthorityModificationByChangeRequest(this.sharedAuthority.id, this.authorityChangeRequestId);
      this.isActionAllowed = loggedInEicStatus === Status.CHANGE_DISPATCHER_APPROVED.toString();
    } else if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_REJECTED_MODIFICATION) {
      this.acceptLabel = AppConstant.EMPTY_STRING;
      this.rejectLabel = AppConstant.EMPTY_STRING;
      this.isActionAllowed = true;
      this.rejectModification = true;
      this.authorityChangeRequestId =
        this.sharedAuthorityNotification.item.authorityChangeRequestId || this.sharedAuthority.rejectedChangeRequestId;
      this.getAuthorityModificationByChangeRequest(this.sharedAuthority.id, this.authorityChangeRequestId);
      this.dataService.setUserNotificationAcknowledgement(
        [this.sharedAuthorityNotification.item.id || this.sharedAuthority.notificationId],
        this.sharedAuthority
      );
    } else {
      this.isActionAllowed = false;
    }
  }

  acceptSharedRequest(): void {
    if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_SHARED) {
      this.actionForUserConfirmation = Status.SHARING_AUTHORITY;
      this.requestStatus = Status.SHARED_AUTHORITY_ACCEPTED;
    } else if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_RELEASED) {
      this.actionForUserConfirmation = Status.SHARING_RELEASE;
      this.requestStatus = Status.UNSHARE_ACCEPTED;
    } else if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_SHARE_REQUEST) {
      this.actionForUserConfirmation = null;
      this.requestStatus = Status.SHARING_INITIATED;
    } else if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_MODIFIED) {
      this.actionForUserConfirmation = Status.CHANGE_REQUEST;
      this.requestStatus = Status.CHANGE_PROPOSED_PARTIALLY_ACCEPTED;
    } else if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_ACCEPTED_MODIFICATION) {
      this.actionForUserConfirmation = Status.CHANGE_REQUEST;
      this.requestStatus = Status.CHANGE_REQUEST;
    } else if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_ACCEPTED_MODIFICATION_DISPATCHER) {
      this.actionForUserConfirmation = Status.CHANGE_REQUEST;
      this.requestStatus = Status.CHANGE_USER_APPROVED;
    }

    if (this.showaffirmations) {
      this.authorityForUserConfirmation = this.sharedAuthority;
      return;
    }
    this.acceptedAuthority(this.sharedAuthority);
  }
  acceptedAuthority(trackAuthority: TrackAuthority): void {
    this.eventBusService.fireEvent(EventType.BLOCK_UI_EVENT, null);
    this.showConfirmation = false;
    const ChangeRequest = {
      id: Number(this.sharedAuthority.id),
      authorityChangeRequestId: this.authorityChangeRequestId,
      status: this.requestStatus
    };

    const ChangeRequestBody: any = {
      status: this.requestStatus,
      confirmation: this.showaffirmations ? trackAuthority.userConfirmationList : []
    };

    if (this.actionForUserConfirmation) {
      ChangeRequestBody.confirmationAction = this.actionForUserConfirmation;
    }
    this.postChangeRequest(ChangeRequest, ChangeRequestBody, true);
  }

  private postChangeRequest(ChangeRequest, ChangeRequestBody, isAcceptedChangeRequest) {
    this.dataService.changeRequest(ChangeRequest, ChangeRequestBody, this.sharedAuthority).then(
      () => {
        if (isAcceptedChangeRequest) {
          if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_ACCEPTED_MODIFICATION) {
            let successText = `Authority #${this.sharedAuthority.ec1Number}: Modification request sent to Dispatcher`;
            this.fireSuccessEvent(successText);
          } else if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_ACCEPTED_MODIFICATION_DISPATCHER) {
            let successText = `Authority #${this.sharedAuthority.ec1Number}: Request sent to Dispatcher`;
            this.fireSuccessEvent(successText);
          } else if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_MODIFIED) {
            let successText = `Authority #${this.sharedAuthority.ec1Number}: Notified Proposed Modification with other users`;
            this.fireSuccessEvent(successText);
          }
        }
        this.closeAllModel();
      },
      error => {
        this.closeAllModel();
      }
    );
  }

  private fireSuccessEvent(successText: String) {
    this.eventBusService.fireEvent(
      EventType.NOTIFY_SUCCESS_EVENT,
      new ATMEventData(null, () => {
        return successText;
      })
    );
  }

  userCancelled(): void {
    this.displaySharedModal = true;
    this.authorityForUserConfirmation = null;
  }

  rejectSharedAuthority(): void {
    this.showConfirmation = true;
  }

  confirmationAccepted(event: any): void {
    this.eventBusService.fireEvent(EventType.BLOCK_UI_EVENT, null);
    this.rejectedProcess(event.reasonValue)
  }

  private rejectedProcess(reason) {
    if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_SHARED) {
      this.actionForUserConfirmation = Status.CHANGE_USER_APPROVED;
      this.requestStatus = Status.SHARING_INITIATE_REJECTED;
    } else if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_RELEASED) {
      if (this.showReason) {
        this.requestStatus = Status.UNSHARING_REJECTED;
      }else{
      this.actionForUserConfirmation = Status.CHANGE_USER_APPROVED;
      this.requestStatus = Status.UNSHARE_ACCEPTED;
      }          
    } else if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_SHARE_REQUEST) {
      this.actionForUserConfirmation = Status.CHANGE_USER_APPROVED;
      this.requestStatus = Status.SHARING_REQUEST_REJECTED;
    } else if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_MODIFIED) {
      this.actionForUserConfirmation = Status.CHANGE_USER_APPROVED;
      this.requestStatus = Status.CHANGE_PROPOSED_REJECTED;
    } else if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_MODIFIED_SUBMIT) {
      this.actionForUserConfirmation = Status.CHANGE_USER_APPROVED;
      this.requestStatus = Status.SHARED_AUTHORITY_ACCEPTED;
    } else if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_ACCEPTED_MODIFICATION) {
      this.actionForUserConfirmation = Status.CHANGE_USER_APPROVED;
      this.requestStatus = Status.CHANGE_PROPOSED_CANCELED;
    } else if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_ACCEPTED_MODIFICATION_DISPATCHER) {
      this.actionForUserConfirmation = Status.CHANGE_USER_APPROVED;
      this.requestStatus = Status.CHANGE_USER_REJECTED;
    }
    this.showConfirmation = false;

    const ChangeRequest = {
      id: Number(this.sharedAuthority.id),
      authorityChangeRequestId: this.authorityChangeRequestId,
      status: this.requestStatus
    };

    const ChangeRequestBody = {
      status: this.requestStatus,
      confirmationAction: this.actionForUserConfirmation,
      confirmation: [],
      comment: reason || ''
    };

    this.postChangeRequest(ChangeRequest, ChangeRequestBody, false);
  }

  public closeAllModel() {
    this.eventBusService.fireEvent(EventType.RELEASE_UI_EVENT, null);
    this.authorityForUserConfirmation = null;
    this.showConfirmation = false;
    this.dataService.openSharedAuthorityModel(false);
  }

  confirmationCancelled(): void {
    this.showConfirmation = false;
  }

  private setAuthorityRequestLoginUser() {
    this.text = AppConstant.SHARED_BY;
    this.authorityChangeRequestId =
      this.authority.eicChangeRequests[this.authority.loggedInEICDetail?.eicUserId] &&
      this.authority.eicChangeRequests[this.authority.loggedInEICDetail.eicUserId].authorityChangeRequestId;
    this.primaryUserRacf = this.authority.primaryUserDetail.eicUserId;
    this.sharedby = `${this.authority.primaryUserDetail.eicUserId} - ${this.authority.primaryUserDetail.eicEmployeeName}`;
  }

  private getRacf(message: String) {
    return message.substring(message.lastIndexOf(' - ') - 6, message.lastIndexOf(' - '));
  }

  private isLoadingUI(value: boolean) {
    this.blocked = value;
  }

  private getAuthorityModificationByChangeRequest(authority_id: number, changeRequest_id: number) {
    if (!changeRequest_id) {
      return;
    }
    this.isLoadingUI(true);
    this.dataService.getAuthorityModificationByChangeRequest(authority_id, changeRequest_id).subscribe(
      (data: IAuthorityHistoryModel) => {
        this.isLoadingUI(false);
        this.showModification = true;
        this.authorityHistoryChange = data.authorityInfoChangeModels;
        if (this.sharedAuthorityNotification.type === AppConstant.AUTHORITY_REJECTED_MODIFICATION) {
          data.rejectedBy = data.rejectedById || AppConstant.DISPATCHER_TEXT;
        } else {
          data.rejectionReason = '';
        }
        this.authorityHistoryCommonChange = this.getAuthorityHistoryCommonChange(data);
      },
      error => {
        this.eventBusService.fireEvent(EventType.RELEASE_UI_EVENT, null);
        console.log(error);
      }
    );
  }

  private getAuthorityHistoryCommonChange(authorityHistory: IAuthorityHistoryModel) {
    let commonChangeData: IAuthorityHistoryCommonChange = {
      requestedById: authorityHistory.requestedById,
      changeTimeStamp: authorityHistory.changeTimeStamp,
      dispatcher: authorityHistory.dispatcher,
      requestedByName: authorityHistory.requestedByName,
      changeType: authorityHistory.changeType,
      rejectedByName: authorityHistory.rejectedByName,
      rejectedById: authorityHistory.rejectedBy,
      rejectionReason: authorityHistory.rejectionReason
    };
    return commonChangeData;
  }
}
